import { AbandonedCardRules } from "./abandoned-card-rules.abstract";

export class DefaultRulesService extends AbandonedCardRules {
  abandonedIcon = "/assets/images/tcb/tcb-clock-icon.svg";
}
